import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { RepresentantePipeSharedModule } from '../../../pessoa/representante/pipes';

import { ClienteGrupoEconomicoSelectComponent } from './select';

@NgModule({
    imports: [
        SharedModule,
        RepresentantePipeSharedModule
    ],
    declarations: [
        ClienteGrupoEconomicoSelectComponent
    ],
    exports: [
        SharedModule,

        ClienteGrupoEconomicoSelectComponent
    ],
    providers: [ ]
})
export class ClienteGrupoEconomicoSharedModule { }
